import axios from 'axios';
import qs from 'qs';

const getBaseURL = () => {
  const teamscheck = localStorage.getItem('inTeams') === 'true';
  const customDomain = localStorage.getItem('custom_domain');
  if (teamscheck && customDomain) {
    const cleanDomain = customDomain.replace(/^https?:\/\//, '').replace(/\/$/, '');
    return `https://${cleanDomain}/iv1/`;
  }
  return `${window.location.origin}/iv1/`;
};

const integrationapi = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

integrationapi.interceptors.request.use(
  (config) => {
    config.baseURL = getBaseURL();
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

integrationapi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log("401 Unauthorized");
    }
    return Promise.reject(error);
  }
);

export default integrationapi;
